import React from 'react';

type ImageV1Props = {
    src: string,
    alt?: string,
    loading?: "lazy" | "eager",
    classes?: string[],
}

const ImageV1 = (props: ImageV1Props) => {

    let classes = ['image-v1'];
    if (Array.isArray(props.classes)) {
        classes.push(...props.classes);
    }

    return (
        <img 
            className={classes.join(' ')}
            src={props.src}
            alt={props.alt}
        />
    );

}

export default ImageV1;